module.exports = __webpack_public_path__ + "static/dice-5e0cc6842fdf39e4a7bf69a61fa15151.jpg";